import React from 'react';
import { SectionHome } from '../components/SectionHome/SectionHome';

export const Home = () => {
  return (
    <>
      <SectionHome />
    </>
  );
};